import { AttackApi, AttackKindApi, AttackMechanismApi, AttackTacticApi } from "@kdmanalytics/brm-system";
import BrmApiClient from "services/brm/BrmApiClient";

export const attackApi = new AttackApi(BrmApiClient.instance);
export const attackKindApi = new AttackKindApi(BrmApiClient.instance);
export const attackMechanismApi = new AttackMechanismApi(BrmApiClient.instance);
export const attackTacticApi = new AttackTacticApi(BrmApiClient.instance);
